<template>

    <div id="app" v-if="!closed">
        <keep-alive>
            <router-view  v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view  v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <div v-else style="text-align: center;font-size: 16px;color: red;margin-top: 40%">
        站点已关闭
    </div>

</template>

<script>
    export default {
        name: 'app',
        data(){
          return {
              closed:false,
          }
        },
        created(){
            this.systemConfig();
        },
        methods:{
            go_login:function () {
                this.$router.push(
                    {
                        name:  this.werouter.login.name,
                        query: { redirect_name:  this.werouter.index.name,}
                    }).catch(function () {})
            },
            systemConfig: function () {
                let that = this;
                this.weapi.request({
                    url: 'system_config',
                    method: 'get',
                    params: {app_id:this.westore.state.app.app_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        this.closed = false;
                        this.westore.commit('setSystemInfo',res.data.data);
                    }
                    else {
                        this.closed = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
        }
    }
</script>

<style>

    #app {
        /*font-family: "Avenir", Helvetica, Arial, sans-serif;*/
        /*-webkit-font-smoothing: antialiased;*/
        /*-moz-osx-font-smoothing: grayscale;*/
        /*text-align: center;*/
        /*color: #2c3e50;*/
        /*margin-top: 60px;*/
    }

    .weball-font-10 {
        font-size: 10px;
    }

    .weball-font-12 {
        font-size: 12px;
    }

    .weball-font-14 {
        font-size: 14px;
    }

    .weball-font-16 {
        font-size: 16px;
    }

    .weball-font-18 {
        font-size: 18px
    }

    .weball-font-20 {
        font-size: 20px
    }

    .weball-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .weball-padding-x-10 {
        padding-left: 10px;
        padding-right: 10px;
    }

    .weball-padding-x-5 {
        padding-left: 5px;
        padding-right: 5px;
    }

    .weball-font-color-main {
        color: #1aad19;
    }

    .weball-font-color-highlight {
        color: #ee0a24;
    }

    .weball-font-color-sub {
        color: #1989fa;
    }
    .weball-font-color-cate {
        color: #7aa0c9;
    }

    .weball-font-color-war {
        color: #ed6a0c;
    }

    .weball-font-color-subtext {
        color: #999;
    }

    .weball-font-color-maintext {
        color: #333;
    }

    .break-word {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .avatar-wrap {
        height: 100%;
        padding: 0 10px 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        max-width: 72px;
        max-height: 72px;
    }

    .row-conent {
        position: relative;
        height: 100%;
        padding: 0 10px 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
    }
    .column-center{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
    }
</style>
